/* eslint-disable react-hooks/exhaustive-deps */
import { Grid } from "@mui/material";
import Paper from "@mui/material/Paper";
import FormService from "Lib/API/Forms";
import MemberService from "Lib/API/Member";
import CardImage from "assets/icons/EventInfoImg.png";
import { ContactUs } from "components/ContactUs/ContactUs";
import { useFormik } from "formik";
import * as calculation from "helper/Calculate";
import { checkIsStripe, checkIsTranzila } from "helper/checkIsStripe";
import { getDateFormat } from "helper/dateFormat";
import { postalCodeFormat, postalCodeLabel } from "helper/postalCodeFormat";
import { useMobileView } from "hook/mobileView/useMobileView";
import moment from "moment";
import { useSnackbar } from "notistack";
import { emailRegex } from "utils/validation";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { useParams } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import { Class } from "services/api/class";
import DonationBox from "components/DonationBox/DonationBox";
import FinanceService from "Lib/API/Finance";
import Header from "./Header/Header";
import { PaymentCard } from "./PaymentCard/PaymentCard";
import { PaymentResultPage } from "./PaymentResultPage/PaymentResultPage";
import { PersonalDetailsCard } from "./PersonalDetailsCard/PersonalDetailsCard";
import { SummaryCard } from "./SummaryCard/SummaryCard";
import {
  CardContent,
  ImageCard,
  ImageContainer,
  PaymentButtonSubmit,
  Wrapper,
} from "./Theme";
import { Ticket } from "./Tickets/Ticket";
import { getAccessTokenSilently, getAuthenticated } from "utils/functions";
import { convenienceFeeAmount as calcConvenienceFee } from "helper/convenienceFee";

export const ReservationSchoolPage = () => {
  const allowInstallmentsOrganization =
    localStorage.getItem("allowInstallments") === "true";
  const isAuthenticated = getAuthenticated();
  const isAuth =
    localStorage.getItem("memberPortal") === "true" ? isAuthenticated : false;
  const { enqueueSnackbar } = useSnackbar();
  const { isMobile } = useMobileView();
  const addCardStripeRef = useRef(null);
  const recaptchaRef = useRef();
  const dateFormat = getDateFormat();
  const params = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const { products, resgistrationForm, totalProducts } = useSelector(
    (state) => state?.Class,
  );
  const { classDetails, numberOfTickets } = useSelector(
    (state) => state?.Class,
  );
  const { logoImage } = useSelector((state) => state.organization);

  const postalLabel = postalCodeLabel();

  const [isLoading, setLoading] = useState(false);
  const [isLoadingPay, setLoadingPay] = useState(false);
  const [calcPriceFailed, setCalcPriceFailed] = useState(false);
  const [error, setError] = useState({ value: true, message: "" });
  const [isCheckedApplay, setIsCheckedApplay] = useState(false);
  const [newProducts, setProducts] = useState([]);
  const [selectedCard, setSelectedCard] = useState(null);
  const [selectedAchCard, setSelectedAchCard] = useState(null);

  const logo = isAuth ? logoImage : localStorage.getItem("logoImgSchool");
  const paymentMethod = JSON.parse(localStorage.getItem("paymentMethodSchool"));
  const achPaymentMethod = JSON.parse(
    localStorage.getItem("achPaymentMethodSchool"),
  );
  const token = localStorage.getItem("token");
  const formData = new FormData();
  const [firstRender, setFirstRender] = useState(false);
  const [checkoutDonationLedger, setCheckoutDonationLedger] = useState(null);
  const [donationAmount, setDonationAmount] = useState(0);
  const [isLoadingDonationLedger, setIsLoadingDonationLedger] = useState(true);
  const [calcDueAmount, setCalcDueAmount] = useState(null);

  const handleTotalForPay = () => {
    const totalforAllTicketsAfterDiscount = calculation.calculateTotalPayment(
      classDetails,
      numberOfTickets,
      "school",
      isAuth,
    );
    return {
      total: (+totalforAllTicketsAfterDiscount + +totalProducts + +donationAmount).toFixed(2),
      totalcountTickets: (+totalPayforAllTickets).toFixed(2),
    };
  };
  const totalPay = handleTotalForPay();
  const isTherePayment = totalPay?.total !== "0.00" || totalProducts > 0;

  const hasInstallmentOption = useCallback(() => {
    const prices = classDetails?.class_pricing?.prices;
    const hasInstallmentInProducts = newProducts.some(
      (product) => product?.installmentStatus,
    );
    const hasInstallmentInTicketVariants = prices?.some(
      (item) => item?.type === "onRegistration" && item?.installmentStatus,
    );

    return hasInstallmentInProducts || hasInstallmentInTicketVariants;
  }, [newProducts, classDetails]);
  const hasInstallment = hasInstallmentOption();

  const enableCreditCardPay = paymentMethod?.allow_member || !isAuth;
  const enableAchPay =
    achPaymentMethod?.allow_member && checkIsStripe(achPaymentMethod);
  const disabledCreditCardPay =
    hasInstallment && !paymentMethod?.allowMemberInstallment && isAuth;
  const disabledAchPay =
    (hasInstallment && !achPaymentMethod?.allowMemberInstallment) ||
    (enableAchPay && !isAuth);
  const displayAchTooltip = useMemo(
    () => (enableAchPay && !isAuth ? "Please login to pay with ACH" : ""),
    [enableAchPay, isAuth],
  );

  const isInstallmentEnabled = useMemo(() => {
    if (!allowInstallmentsOrganization) {
      return false;
    }

    return isAuth
      ? paymentMethod?.allowMemberInstallment ||
          achPaymentMethod?.allowMemberInstallment
      : true;
  }, [allowInstallmentsOrganization, isAuth, paymentMethod, achPaymentMethod]);

  const initialActivePayment = useMemo(() => {
    if (isAuth) {
      if (enableCreditCardPay) return "credit-card";
      if (enableAchPay) return "ach";
      return "";
    }
    return "credit-card";
  }, [isAuth, enableCreditCardPay, enableAchPay]);

  const formik = useFormik({
    isInitialValid: false,
    enableReinitialize: true,
    initialValues: {
      registrationForm: [],
      errors: [],
      ticketsData: Array.from({ length: numberOfTickets?.length }, () => [
        ...products,
      ]),
      dropdowns: [],
      accountInfo: {
        first_name: "",
        last_name: "",
        primary_email_address: "",
      },
      cardsDetails: {},
      resultPage: "",
      activePayment: initialActivePayment,
    },
    validationSchema: false,
    onSubmit: async (values) => {},
  });

    const activePayment = formik?.values?.activePayment;
  const [convenienceFeeByPayment, setConvenienceFeeByPayment] = useState({
    "credit-card": true,
    ach: true,
  });

  const resetInstallment = () => {
    if (
      classDetails?.class_pricing?.prices === undefined ||
      !classDetails?.class_pricing?.prices?.length
    )
      return;
    const updatedClassPricing = classDetails?.class_pricing?.prices?.map(
      (item) => {
        return {
          ...item,
          installmentStatus: false,
          installment: null,
        };
      },
    );
    const updatedClassDetails = {
      ...classDetails,
      class_pricing: {
        ...classDetails?.class_pricing,
        prices: updatedClassPricing,
      },
    };
    dispatch(Class.actions.setClassDetails(updatedClassDetails));
  };

  useEffect(() => {
    const fetchCheckoutDonationLedger = async () => {
      try {
        const orgToken = isAuth
          ? await getAccessTokenSilently()
          : localStorage.getItem("schoolToken");
        const orgId = localStorage.getItem("schoolOrgId");
        const res = await FinanceService.getCheckoutDonationLedger(orgToken, orgId);
        if (res?.ledger) setCheckoutDonationLedger(res.ledger);
      } catch (_) {} finally {
        setIsLoadingDonationLedger(false);
      }
    };
    fetchCheckoutDonationLedger();
  }, []);

  useEffect(() => {
    if (!firstRender && numberOfTickets.length > 0) {
      formik.setFieldValue(
        "ticketsData",
        Array.from({ length: numberOfTickets?.length }, () => [...products]),
      );
      setFirstRender(true);
    }
    resetInstallment();
  }, [numberOfTickets]);
  const formDataReservation = formik?.values?.registrationForm || [];

  const totalPayforAllTickets = useMemo(
    () => classDetails?.class_pricing?.total_to_pay * numberOfTickets.length,
    [classDetails, numberOfTickets],
  );

  const totalAmountCalculation = calculation?.calculateDiscount(
    classDetails,
    numberOfTickets,
    "school",
    isAuth,
  );

  const totalPayment = useMemo(
    () => totalAmountCalculation?.totalAfterDiscount?.replace(/,/g, ""),
    [classDetails, numberOfTickets],
  );

  const totalDiscount = totalAmountCalculation?.totalDiscount;

  const thereIsFormEmpty = useMemo(
    () => formDataReservation?.some((item) => item?.formData?.length === 0),
    [formDataReservation],
  );

  // True when all required registration-form fields have values.
  // Used to keep the Tranzila payment overlay active until the form is ready.
  const isRegistrationFormValid = useMemo(() => {
    if (thereIsFormEmpty) return false;
    const requiredFields = resgistrationForm || [];
    for (const item of formik?.values?.registrationForm || []) {
      for (const subItem of item?.formData || []) {
        const required = requiredFields.find(
          (r) => r.id === subItem.id && r.required,
        );
        if (!required) continue;
        if (!subItem.value || subItem?.value?.length === 0) return false;
        if (subItem?.name?.includes("email_input")) {
          if (!emailRegex.test(subItem.value)) return false;
        }
      }
    }
    return true;
  }, [thereIsFormEmpty, formik?.values?.registrationForm, resgistrationForm]);

  const getFormById = async () => {
    // restore selected deropDown List
    dispatch(Class.actions.resetAction([]));
    //  Get data for the first time (without any update on varients) when page loads
    dispatch(
      Class.actions.setVarients(
        JSON.parse(localStorage.getItem("originVarients")),
      ),
    );
    try {
      setLoading(true);
      const token = isAuth
        ? await getAccessTokenSilently()
        : localStorage.getItem("schoolToken");
      const res = await FormService.getFormById(
        token,
        classDetails?.form,
        localStorage.getItem("schoolOrgId"),
      );
      dispatch(Class.actions.setRegistartionDetails(res?.task_data));
    } catch (error) {
      enqueueSnackbar(error?.data?.message, {
        variant: "error",
      });
      dispatch(Class.actions.setRegistartionDetails({}));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    localStorage.removeItem("redirectUrl");
    return () => {
      localStorage.setItem("registrationForm", []);
      localStorage.setItem("ApplayCheckBox", JSON.stringify(false));
    };
  }, []);

  const getCurrentPaymentMethod = useCallback(() => {
    if (formik?.values?.activePayment === "credit-card") {
      return paymentMethod;
    }
    if (formik?.values?.activePayment === "ach") {
      return achPaymentMethod;
    }
    return null;
  }, [paymentMethod, achPaymentMethod, formik.values?.activePayment]);

  const currentPaymentMethod = useMemo(() => getCurrentPaymentMethod(), [
    getCurrentPaymentMethod,
  ]);
  const isStripe = useMemo(() => checkIsStripe(currentPaymentMethod), [
    currentPaymentMethod,
  ]);
  const isTranzila = useMemo(() => checkIsTranzila(currentPaymentMethod), [
    currentPaymentMethod,
  ]);

  const convenienceFee = useMemo(() => {
    if (!currentPaymentMethod) return 0;
    const shouldApplyConvenienceFee =
      currentPaymentMethod.coverConvenienceFee &&
      convenienceFeeByPayment[activePayment];

    if (!shouldApplyConvenienceFee) return 0;

    const baseForCF = totalPay?.total - donationAmount;
    return calcConvenienceFee(currentPaymentMethod?.convenienceFeeInfo, baseForCF);
  }, [totalPay, donationAmount, currentPaymentMethod, convenienceFeeByPayment, activePayment]);

  const totalPaymentWithCVFee = +totalPay?.total + +convenienceFee;
  const dueAmountConvenienceFee = useCallback(
    (totalDueAmount) => {
      if (!currentPaymentMethod) return 0;
      const shouldApplyConvenienceFee =
        currentPaymentMethod.coverConvenienceFee &&
        convenienceFeeByPayment[activePayment];

      if (!shouldApplyConvenienceFee) return 0;
      return calcConvenienceFee(
        currentPaymentMethod?.convenienceFeeInfo,
        totalDueAmount,
      );
    },
    [currentPaymentMethod, convenienceFeeByPayment, activePayment],
  );

  const calculateAmountProducts = (items, type = "ticket") => {
    return items.reduce((total, item) => {
      const installmentValue =
        item?.installmentStatus && item?.installment?.value;
      const itemAmount =
        type === "ticket"
          ? item?.amount * item?.selectedQuantity
          : item?.amount;
      return (
        total + (installmentValue ? itemAmount / installmentValue : itemAmount)
      );
    }, 0);
  };

  const calculateAmount = (items) => {
    return items?.reduce((sum, item) => {
      if (item?.type === "onRegistration") {
        return (
          sum +
          (item?.installmentStatus && item?.installment?.value
            ? item.amount / item?.installment?.value
            : item.amount)
        );
      }
      return sum;
    }, 0);
  };

  const calculateDueAmount = () => {
    const totalTicketAmount = calculateAmount(
      classDetails?.class_pricing?.prices,
    );
    const totalProductAmount = calculateAmountProducts(newProducts, "product");
    const {
      totalAfterDiscount,
      discountTotal,
    } = calculation.calculateDueDiscount(
      totalTicketAmount,
      classDetails?.class_discount,
      numberOfTickets,
      isAuth,
    );
    const totalDueAmount = +totalProductAmount + +totalAfterDiscount + donationAmount;
    const convenienceFeeAmount = dueAmountConvenienceFee(totalDueAmount);
    return {
      totalDueAmount,
      dueAmountCF: convenienceFeeAmount,
      totalDueAmountWithCF: totalDueAmount + convenienceFeeAmount,
      dueAmountTotalDiscount: discountTotal,
    };
  };

  const convertDateToUsFormat = (formData) => {
    return formData.map((item) => {
      if (item?.name.includes("date_picker")) {
        return {
          ...item,
          value: moment(item?.value, dateFormat).format("MM/DD/YYYY"),
        };
      }
      return item;
    });
  };

  const updatedFormDataWithDatePicker = (formDataItem) => {
    let formDataArray = [];
    formDataItem.forEach((item) => {
      if (item?.name?.includes("date_picker")) {
        const datePickerField = document.querySelector(`[name="${item.name}"]`);
        formDataArray.push({
          ...item,
          value: datePickerField.value || null,
        });
      } else {
        formDataArray.push(item);
      }
    });
    return formDataArray;
  };

  const installmentOnRegistrationPrices = () => {
    const prices = classDetails?.class_pricing?.prices;
    const installmentPrices = prices
      ?.map((item) => {
        if (item?.type === "onRegistration" && item?.installmentStatus) {
          return {
            priceId: item?._id,
            numberOfInstallment: item?.installment?.value,
          };
        }
      })
      .filter((item) => item !== undefined);
    return installmentPrices;
  };

  const updatedProductsData = (products) => {
    return products.map((product) => {
      const currentProduct = newProducts?.find(
        (item) => item.title?.toLowerCase() === product?.title?.toLowerCase(),
      );
      const hasInstallment = currentProduct?.installmentStatus;
      return {
        ...product,
        ...(hasInstallment
          ? { numberOfInstallments: currentProduct?.installment?.value }
          : {}),
      };
    });
  };

  const ConvertFormToFormData = (data) => {
    const dataArray = [...data];
    if (dataArray[0] !== undefined) {
      // TODO: Replace map with forEach since there is nothing returned from the map
      const formDataArray = dataArray.map((dataItem, dataIndex) => {
        const { id, formData: formDataItem, products } = dataItem;
        const filteredFormData = convertDateToUsFormat(formDataItem);
        // ? Check if this is in use; if not, consider deleting it.
        const updatedFormData = updatedFormDataWithDatePicker(filteredFormData);
        const updatedProducts = updatedProductsData(products);
        const installmentPrices = installmentOnRegistrationPrices();

        formData.append(
          `registrationForm[${dataIndex}][formData]`,
          JSON.stringify([...updatedFormData]),
        );
        formData.append(`registrationForm[${dataIndex}][id]`, `${id}`);
        formData.append(
          `registrationForm[${dataIndex}][products]`,
          JSON.stringify([...updatedProducts]),
        );
        if (installmentPrices?.length > 0) {
          formData.append(
            `installments`,
            JSON.stringify([...installmentPrices]),
          );
        }
        // ? Check if this is in use; if not, consider deleting it.
        const formDataObj = formDataItem?.forEach((dataItem) => {
          if (dataItem?.name?.includes("file_upload")) {
            if (dataItem?.value && dataItem?.value !== null) {
              formData.append(
                `registrationForm[${dataIndex}][files][${id}]`,
                dataItem?.value,
              );
            }
          }
        });
      });
    }
  };
  const handleDataForTwoFlow = (tokenId = "", coverFee = true, tranzilaChargeResult = null) => {
    formData.append(`isMember`, isAuth ? true : false);
    if (!isAuth) {
      formData.append(`orgId`, localStorage.getItem("schoolOrgId"));
    }
    formData.append(`classId`, params?.id);
    formData.append("coverFee", coverFee);

    const objectName = "cardsDetails";
    const objectData = formik?.values?.cardsDetails;

    if (formik?.values?.activePayment === "credit-card") {
      formData.append("paymentMethodId", paymentMethod?._id);
      if (isAuth) {
        formData.append("cardId", selectedCard);
      } else if (tranzilaChargeResult) {
        formData.append("tranzilaChargeResult", JSON.stringify(tranzilaChargeResult));
      } else if (tokenId) {
        formData.append("token", tokenId);
      } else {
        for (const key in objectData) {
          if (key === "expiry") {
            formData.append(
              `${objectName}[exp_month]`,
              objectData[key]?.split("/")[0],
            );
            formData.append(
              `${objectName}[exp_year]`,
              objectData[key]?.split("/")[1],
            );
          } else if (key === "card_number") {
            formData.append(`${objectName}[number]`, objectData[key]);
          } else {
            formData.append(`${objectName}[${key}]`, objectData[key]);
          }
        }
      }
    } else if (formik?.values?.activePayment === "ach") {
      formData.append("paymentMethodId", achPaymentMethod?._id);
      if (isAuth) {
        formData.append("cardId", selectedAchCard);
      }
    }

    // Checkout donation
    if (donationAmount > 0 && checkoutDonationLedger) {
      formData.append("checkoutDonation[ledger_id]", checkoutDonationLedger._id || checkoutDonationLedger.ledger_id || "");
      formData.append("checkoutDonation[ledger_name]", checkoutDonationLedger.ledger_name || "");
      formData.append("checkoutDonation[amount]", donationAmount);
      if (checkoutDonationLedger.account_receivable) {
        formData.append("checkoutDonation[account_receivable]", checkoutDonationLedger.account_receivable);
      }
    }
    if (isAuth) return;
    // Account Info
    const objectName2 = "accountInfo";
    const objectData2 = formik?.values?.accountInfo;
    for (const key in objectData2) {
      if (key === "addresses") {
        const objeLocation = formik.values?.accountInfo?.addresses[0].location;
        if (Object.keys(objeLocation).length !== 0) {
          formik.values?.accountInfo?.addresses[0].location?.formattedAddress &&
            formData.append(
              `${objectName2}[addresses][0][location][formattedAddress]`,
              formik.values?.accountInfo?.addresses[0].location
                ?.formattedAddress,
            );
          formik.values?.accountInfo?.addresses[0].location?.place_id &&
            formData.append(
              `${objectName2}[addresses][0][location][place_id]`,
              formik.values?.accountInfo?.addresses[0].location?.place_id,
            );
          formik.values?.accountInfo?.addresses[0]?.city &&
            formData.append(
              `${objectName2}[addresses][0][city]`,
              formik.values?.accountInfo?.addresses[0]?.city,
            );
          formik.values?.accountInfo?.addresses[0]?.state &&
            formData.append(
              `${objectName2}[addresses][0][state]`,
              formik.values?.accountInfo?.addresses[0]?.state,
            );
          formik.values?.accountInfo?.addresses[0]?.zip_code &&
            formData.append(
              `${objectName2}[addresses][0][zip_code]`,
              formik.values?.accountInfo?.addresses[0]?.zip_code,
            );
          formik.values?.accountInfo?.addresses[0]?.addressLine2 &&
            formData.append(
              `${objectName2}[addresses][0][addressLine2]`,
              formik.values?.accountInfo?.addresses[0]?.addressLine2,
            );
        }
      } else {
        formData.append(`${objectName2}[${key}]`, objectData2[key]);
      }
    }
  };

  // get stripe token
  const handleGetStripeToken = async () => {
    const tokenId = await addCardStripeRef?.current?.handleGetToken();
    if (tokenId && tokenId !== null && token !== undefined) {
      return tokenId;
    }
    return "";
  };

  const isValidInstallment = () => {
    const prices = classDetails?.class_pricing?.prices;
    let isValid = true;

    const products = newProducts.forEach((item) => {
      if (item?.installmentStatus && !item?.installment?.value) {
        isValid = false;
      }
    });

    const tickets = prices?.forEach((item) => {
      if (
        item?.type === "onRegistration" &&
        item?.installmentStatus &&
        !item?.installment?.value
      ) {
        isValid = false;
      }
    });
    return isValid;
  };

  // Api For Pay
  const handleTranzilaCharged = async (result) => {
    // Validate required registration fields before completing the registration.
    // The Tranzila iframe fires this callback after the card charge, so we must
    // check here to prevent a registration record being created with missing data.
    if (thereIsFormEmpty) {
      return enqueueSnackbar(
        "You have errors in filling out the form, please check them",
        { variant: "error" },
      );
    }
    const requiredFields = resgistrationForm;
    const dataValidation = formik?.values?.registrationForm?.map((item) => ({
      ...item,
      formData: item?.formData
        ?.map((subItem) => {
          const required = requiredFields?.find(
            (r) => r.id === subItem.id && r.required,
          );
          if (subItem?.name?.includes("date_picker") && required) {
            const el = document.querySelector(`[name="${subItem.name}"]`);
            return {
              errorMessage:
                !el?.value ? `The ${required?.label} is required` : "",
            };
          }
          if (subItem?.name?.includes("file_upload") && required) {
            return {
              errorMessage:
                !subItem.value?.name ? `The ${required?.label} is required` : "",
            };
          }
          if (subItem.value && subItem?.value?.length > 0) {
            if (subItem?.name?.includes("email_input")) {
              return {
                errorMessage: emailRegex.test(subItem.value)
                  ? ""
                  : `Please enter valid email for (${required?.label}) field`,
              };
            }
            return { errorMessage: "" };
          }
          if (required) {
            return { errorMessage: `The ${required.label} is required` };
          }
          return { errorMessage: "" };
        })
        .filter((e) => e.errorMessage !== ""),
    }));
    formik.setFieldValue("errors", dataValidation);
    const allErrorsEmpty = dataValidation.every(
      (item) => item.formData.length === 0,
    );
    if (!allErrorsEmpty) {
      return enqueueSnackbar(
        "You have errors in filling out the form, please check them",
        { variant: "error" },
      );
    }

    handleDataForTwoFlow("", true, result);
    ConvertFormToFormData(formDataReservation);
    setLoadingPay(true);
    try {
      const token = localStorage.getItem("schoolToken");
      await MemberService.CreateParticipant(formData, token);
      formik.setFieldValue("resultPage", "success");
    } catch (err) {
      enqueueSnackbar(err?.data?.message || "Payment failed, please try again", { variant: "error" });
    } finally {
      setLoadingPay(false);
    }
  };

  const PayNow = async (hasStripe) => {
    const isFreeRegistration = totalPay?.total === "0.00" && totalProducts <= 0;
    if (!formik?.values?.activePayment && !isFreeRegistration) return;
    const captchaValue = recaptchaRef?.current?.getValue();
    if (
      !captchaValue &&
      !isAuth &&
      (totalPay?.total !== "0.00" || totalProducts > 0)
    )
      return enqueueSnackbar("Please verify the captcha", {
        variant: "info",
      });

    if (isLoadingPay) return;
    const thereIsFormEmpty = formDataReservation?.some(
      (item) => item?.formData?.length === 0,
    );
    if (thereIsFormEmpty) {
      enqueueSnackbar(
        "You have errors in filling out the form , please check them",
        {
          variant: "error",
        },
      );
    } else {
      const requiredFields = resgistrationForm;
      const dataValidation = formik?.values?.registrationForm?.map(
        (item, index) => {
          return {
            ...item,
            formData: item?.formData
              ?.map((subItem, subItemIndex) => {
                const requireds = requiredFields?.find(
                  (tofinditem) =>
                    tofinditem.id === subItem.id && tofinditem.required,
                );
                if (
                  subItem?.name.includes("date_picker") &&
                  requireds !== undefined
                ) {
                  const datePickerField = document.querySelector(
                    `[name="${subItem.name}"]`,
                  );
                  if (
                    !datePickerField.value ||
                    datePickerField.value === undefined
                  ) {
                    return {
                      errorMessage: `The ${requireds?.label} is required`,
                    };
                  } else {
                    return { errorMessage: "" };
                  }
                }
                if (
                  subItem?.name.includes("file_upload") &&
                  requireds !== undefined
                ) {
                  if (
                    !subItem.value?.name ||
                    subItem.value?.name === undefined
                  ) {
                    return {
                      errorMessage: `The ${requireds?.label} is required`,
                    };
                  } else {
                    return { errorMessage: "" };
                  }
                }
                if (subItem.value && subItem?.value?.length > 0) {
                  if (subItem?.name.includes("email_input")) {
                    return {
                      errorMessage: emailRegex.test(subItem.value)
                        ? ""
                        : `Please enter valid email for (${requiredFields[subItemIndex]?.label}) field`,
                    };
                  }
                  if (subItem?.name.includes("phone_input")) {
                    const phoneRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
                    return {
                      errorMessage: phoneRegex.test(subItem.value)
                        ? ""
                        : `Please enter valid Phone Number for (${requiredFields[subItemIndex]?.label}) field`,
                    };
                  } else {
                    return { errorMessage: "" };
                  }
                }
                if (requireds !== undefined) {
                  return { errorMessage: `The ${requireds.label} is required` };
                } else {
                  return { errorMessage: "" };
                }
              })
              .filter((element) => element.errorMessage !== ""),
          };
        },
      );
      formik.setFieldValue("errors", dataValidation);
      const allErrorsEmpty = dataValidation.every(
        (item) => item.formData.length === 0,
      );

      if (allErrorsEmpty) {
        const validInstallment = isValidInstallment();
        if (!validInstallment) {
          return enqueueSnackbar("Please select number of installments", {
            variant: "info",
          });
        }

        const validZipCode = postalCodeFormat(
          formik?.values?.cardsDetails?.zip,
        );
        if (
          !isStripe &&
          formik?.values?.cardsDetails?.zip?.length &&
          !validZipCode &&
          formik?.values?.activePayment === "credit-card" &&
          !isAuth
        ) {
          enqueueSnackbar(`Invalid ${postalLabel}`, { variant: "info" });
        }

        let tokenId = "";
        if (
          isStripe &&
          formik?.values?.activePayment === "credit-card" &&
          !isAuth
        ) {
          tokenId = await handleGetStripeToken();
        }

        if (
          isAuth &&
          !selectedCard &&
          formik?.values?.activePayment === "credit-card" &&
          (totalPay?.total !== "0.00" || totalProducts > 0)
        ) {
          enqueueSnackbar("Please select a credit card", { variant: "error" });
        }

        if (
          isAuth &&
          !selectedAchCard &&
          formik?.values?.activePayment === "ach" &&
          (totalPay?.total !== "0.00" || totalProducts > 0)
        ) {
          enqueueSnackbar("Please select an ACH card", { variant: "error" });
          return;
        }

        if (
          (hasStripe && tokenId) ||
          !hasStripe ||
          (isAuth && selectedCard) ||
          (isAuth && selectedAchCard)
        ) {
          handleDataForTwoFlow(
            tokenId || "",
            convenienceFeeByPayment[activePayment],
          );
          ConvertFormToFormData(formDataReservation);
          if (error?.message) {
            enqueueSnackbar(error?.message, {
              variant: "error",
            });
            setLoadingPay(false);
          } else {
            setLoadingPay(true);
            const token = isAuth
              ? await getAccessTokenSilently()
              : localStorage.getItem("schoolToken");
            try {
              await MemberService.CreateParticipant(formData, token).then(
                (res) => {
                  formik.setFieldValue("resultPage", "success");
                },
              );
            } catch (error) {
              const message = error?.data?.message
                ? error?.data?.message
                : "There is something wrong";
              enqueueSnackbar(message, {
                variant: "error",
              });
            } finally {
              setLoadingPay(false);
            }
          }
        }
      } else {
        enqueueSnackbar(
          "You have errors in filling out the form , please check them",
          {
            variant: "error",
          },
        );
      }
    }
  };

  useEffect(() => {
    if (
      Object.keys(classDetails || {}).length !== 0 &&
      !classDetails?.allow_non_members_register &&
      !token
    ) {
      history.push(`/form/${params?.id}`);
    } else {
      if (isAuth) {
        setTimeout(() => {
          const accountDetails = JSON.parse(
            localStorage.getItem("accountInfo"),
          );
          formik.setFieldValue("accountInfo", {
            first_name: accountDetails?.firstName ?? "",
            last_name: accountDetails?.lastName ?? "",
            primary_email_address: accountDetails?.primary_email_address ?? "",
          });
        }, 2000);
      }
      if (Object.keys(classDetails || {}).length !== 0) getFormById();
    }
  }, [isAuth]);

  useEffect(() => {
    // ? why are we setting the field (cardDetails) value to the same field value (formik.values?.cardsDetails) ? (it seems that this is a bug)
    formik.setFieldValue("cardsDetails", formik.values?.cardsDetails);
    if (!isAuth) {
      formik.setFieldValue("accountInfo", formik.values?.accountInfo);
    }
    let keysWithoutData = [];
    if (formDataReservation?.length === 0) {
      numberOfTickets.map((ticketId) => {
        keysWithoutData.push({ id: ticketId, formData: [], products: [] });
      });
      formik.setFieldValue("registrationForm", keysWithoutData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, numberOfTickets, isAuth]);

  const resetReservation = () => {
    formik.setFieldValue(
      "ticketsData",
      Array.from({ length: numberOfTickets?.length }, () => [...products]),
    );
    dispatch(
      Class.actions.setVarients(
        JSON.parse(localStorage.getItem("originVarients")),
      ),
    );
  };

  const handleLogout = () => {
    formik.setFieldValue("accountInfo", {});
    formik.setFieldValue("activePayment", "credit-card");
    resetReservation();
    localStorage.clear();
    window.location.href = `/school/${params?.id}`;
  };

  const setActivePaymentAfter = useCallback(() => {
    if (!isAuth) return formik.setFieldValue("activePayment", "credit-card");
    if (
      paymentMethod?.allowMemberInstallment &&
      achPaymentMethod?.allowMemberInstallment
    )
      return;

    const nextPayment = paymentMethod?.allowMemberInstallment
      ? "credit-card"
      : achPaymentMethod?.allowMemberInstallment
      ? "ach"
      : null;

    if (nextPayment) {
      formik.setFieldValue("activePayment", nextPayment);
    }
  }, [paymentMethod, achPaymentMethod, formik.values?.activePayment]);

  const {
    dueAmountCF,
    totalDueAmountWithCF,
    dueAmountTotalDiscount,
  } = calculateDueAmount();

  return (
    <>
      {formik.values?.resultPage !== "" ? (
        <PaymentResultPage
          result={formik.values?.resultPage}
          formik={formik}
          isTherePayment={totalPay?.total !== "0.00" || totalProducts > 0}
        />
      ) : (
        <>
          <Header Logo={logo} />
          <Wrapper>
            <Grid
              container
              spacing={2}
              sx={{ width: isMobile ? "348px" : "100%" }}
            >
              <Grid item xs={12} sm={12} md={12} lg={7} direction="column">
                <Paper
                  sx={{
                    height: isMobile ? "165px" : "227px",
                    borderRadius: "10px",
                    backgroundColor: (theme) =>
                      theme.palette.mode === "dark" ? "#1A2027" : "#2555EF",
                  }}
                >
                  <ImageContainer isMobile={isMobile}>
                    <CardContent isMobile={isMobile}>
                      <h1>{classDetails?.class_name}</h1>
                    </CardContent>
                    <div>
                      <ImageCard src={CardImage} alt="bg" isMobile={isMobile} />
                    </div>
                  </ImageContainer>
                </Paper>

                {numberOfTickets?.map((item, index) => (
                  <>
                    <Ticket
                      key={`ticket_${isCheckedApplay}`}
                      index={index}
                      formik={formik}
                      ticketUniqueId={item}
                      setIsCheckedApplay={setIsCheckedApplay}
                      isCheckedApplay={isCheckedApplay}
                      totalProducts={totalProducts}
                      handleTotalForPay={handleTotalForPay}
                    />
                    <br />
                  </>
                ))}
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={5} direction="column">
                <div style={{ marginBottom: "16px" }}>
                  <SummaryCard
                    handleTotalForPay={handleTotalForPay}
                    totalPaymentWithCVFee={totalPaymentWithCVFee}
                    isAuthenticated={isAuth}
                    dueAmountCF={dueAmountCF}
                    totalDueAmountWithCF={totalDueAmountWithCF}
                    totalDiscount={totalDiscount}
                    dueAmountTotalDiscount={dueAmountTotalDiscount}
                    isInstallmentEnabled={isInstallmentEnabled}
                    setActivePaymentAfter={setActivePaymentAfter}
                    setProducts={setProducts}
                    newProducts={newProducts}
                    activePayment={activePayment}
                    convenienceFeeByPayment={convenienceFeeByPayment}
                    setConvenienceFeeByPayment={setConvenienceFeeByPayment}
                    currentPaymentMethod={currentPaymentMethod}
                    donationAmount={donationAmount}
                    onCalcDueAmountChange={setCalcDueAmount}
                    onCalcPriceStatusChange={setCalcPriceFailed}
                  />
                </div>

                <PersonalDetailsCard
                  formik={formik}
                  isLoadingPay={isLoadingPay}
                  PayNow={PayNow}
                  error={error}
                  setError={setError}
                  handleTotalForPay={handleTotalForPay}
                  totalProducts={totalProducts}
                  isTherePayment={isTherePayment}
                  showZipCode={!isAuth}
                  isAuthenticated={isAuth}
                  handleLogout={handleLogout}
                />

                <DonationBox
                  ledger={checkoutDonationLedger}
                  loading={isLoadingDonationLedger}
                  onDonationChange={(amount, ledger) => { setDonationAmount(amount); if (ledger) setCheckoutDonationLedger(ledger); }}
                />

                <PaymentCard
                  TotalForPay={totalProducts}
                  formik={formik}
                  setError={setError}
                  error={error}
                  PayNow={PayNow}
                  isLoadingPay={isLoadingPay}
                  handleTotalForPay={handleTotalForPay}
                  thereIsFormEmpty={thereIsFormEmpty}
                  setLoadingPay={setLoadingPay}
                  isStripe={isStripe}
                  isTranzila={isTranzila}
                  currentPaymentMethod={currentPaymentMethod}
                  addCardStripeRef={addCardStripeRef}
                  isAuthenticated={isAuth}
                  setSelectedCard={setSelectedCard}
                  selectedCard={selectedCard}
                  setSelectedAchCard={setSelectedAchCard}
                  selectedAchCard={selectedAchCard}
                  totalDueAmountWithCF={calcDueAmount !== null ? calcDueAmount : totalDueAmountWithCF}
                  recaptchaRef={recaptchaRef}
                  enableCreditCardPay={enableCreditCardPay}
                  enableAchPay={enableAchPay}
                  disabledAchPay={disabledAchPay}
                  displayAchTooltip={displayAchTooltip}
                  disabledCreditCardPay={disabledCreditCardPay}
                  publicKey={
                    currentPaymentMethod?.paymentGateway?.keys?.publicKey
                  }
                  calcPriceFailed={calcPriceFailed}
                  onTranzilaCharged={handleTranzilaCharged}
                  orgId={localStorage.getItem("schoolOrgId")}
                  isRegistrationReady={isRegistrationFormValid}
                />
              </Grid>
            </Grid>

            <ContactUs formOnlineData={classDetails} />
          </Wrapper>
          {handleTotalForPay()?.total === "0.00" && totalProducts <= 0 && (
            <Grid item xs={12}>
              <PaymentButtonSubmit isDisabled={thereIsFormEmpty}>
                <button
                  disabled={thereIsFormEmpty}
                  onClick={() => {
                    PayNow();
                  }}
                >
                  {isLoadingPay ? (
                    <ClipLoader
                      color={"#ffffff"}
                      loading={isLoadingPay}
                      size={32}
                      aria-label="Loading Spinner"
                      data-testid="loader"
                    />
                  ) : (
                    "Submit"
                  )}
                </button>
              </PaymentButtonSubmit>
            </Grid>
          )}
        </>
      )}
    </>
  );
};
